import React from 'react';
import { cn } from '@/lib/utils/utils';

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
  children: React.ReactNode;
}

const sizeClasses = {
  xs: 'text-xs font-medium',
  sm: 'text-sm font-medium',
  md: 'text-base font-semibold',
  lg: 'text-lg font-semibold',
  xl: 'text-xl font-bold tracking-tight',
  '2xl': 'text-2xl font-bold tracking-tight',
  '3xl': 'text-3xl font-extrabold tracking-tight',
  '4xl': 'text-4xl font-extrabold tracking-tight lg:text-5xl'
};

// forwardRef so Heading works as a direct child of Radix `asChild` slots
// (TooltipTrigger, PopoverTrigger, ...), which merge a ref into their child.
export const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  function Heading(
    { as: Component = 'h2', size, className, children, ...props },
    ref
  ) {
    const actualSize =
      size || (Component === 'h1' ? '2xl' : Component === 'h2' ? 'xl' : 'lg');

    return (
      <Component
        ref={ref}
        className={cn(sizeClasses[actualSize], className)}
        {...props}
      >
        {children}
      </Component>
    );
  }
);
